import { Modal } from 'components';
import * as React from 'react';
import styled from 'styled-components';

interface Covid19UploadedPdfModalProps {
  PDFAckFile: string;
  visible: boolean;
  onCancel: () => void;
}

const Covid19UploadedPdfModal: React.FC<Covid19UploadedPdfModalProps> = ({
  onCancel,
  PDFAckFile,
  visible,
}) => (
    <StyledModal centered open={visible} onCancel={onCancel} footer={null}>
      <StyledObject data={PDFAckFile} type="application/pdf" />
    </StyledModal>
  );

const StyledModal = styled(Modal).attrs({
  bodyStyle: {
    minHeight: '50vh',
    minWidth: '80vw',
    maxHeight: '95vh',
    overflow: 'auto',
  },
  width: 'auto',
  zIndex: 10000,
})``;

const StyledObject = styled.object.attrs({ width: '100%' })`
  min-height: 85vh;
  width: 100%;
`;

export default Covid19UploadedPdfModal;
